"use strict";

/**
 * Events welche die Implemetierung des Digitalisierwerkzeugs auslösen.
 * @enum {string}
 */
gc.gis.module.GCDigitizeImplEvent = {
	/**
	 * Wird ausgelöst, wenn der Nutzer das Zeichnen begonnen hat.
	 */
	DRAW_START:     'draw:start',
	/**
	 * Wird ausgelöst, wenn der Nutzer das Zeichnen beendet hat.
	 */
	DRAW_END:       'draw:end'
};

/**
 * @classdesc
 * Abstrakte Digitalisierungs-Interaktion.
 *
 * @class
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmdidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.instance Modul-Instanz
 * @param {gc.gis.map.GCMapView} options.map Karten-Instanz
 */
gc.gis.module.GCDigitize.Impl = function( options )
{
	gc.gis.GCObservable.call(this);

	this.module = options.instance;
	this.map    = options.map;
};
gc.gis.module.GCDigitize.Impl.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Setzt die Zeichnen-Interaktion aktiv bzw. deaktiv.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} active
 */
gc.gis.module.GCDigitize.Impl.prototype.setDrawActive = gc.gis.abstractMethod;

/**
 * Setzt die Bearbeitungs-Interaktion aktiv bzw. deaktiv.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} active
 */
gc.gis.module.GCDigitize.Impl.prototype.setTransformActive = gc.gis.abstractMethod;

/**
 * Setzt die Auswahl-Interaktion aktiv bzw. deaktiv.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} active
 */
gc.gis.module.GCDigitize.Impl.prototype.setSelectActive = gc.gis.abstractMethod;

/**
 * Liefert den zugrundeliegenden Layer.
 *
 * @public
 * @abstract
 * @method
 *
 * @return {gc.gis.layer.GCTrackingLayer}
 */
gc.gis.module.GCDigitize.Impl.prototype.getLayer = gc.gis.abstractMethod;

/**
 * Setzt den Geometrietyp für der Zeichnen-Interaktion.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.geom.GCGeometryType} geometryType Geometrietype der Zeichnen-Interaktion
 */
gc.gis.module.GCDigitize.Impl.prototype.setGeometryType = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn eine Menge von Features erfolgreich gespeichert wurden.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.module.GCDigitize.Impl.prototype.saveSuccess = gc.gis.abstractMethod;

/**
 * Aktiviert oder deaktiviert das Freihandzeichnen.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} enable
 */
gc.gis.module.GCDigitize.Impl.prototype.enableFreehand = gc.gis.abstractMethod;

/**
 * Liefert die Features.
 *
 * @public
 * @method
 *
 * @return {gc.gis.feature.GCFeature[]}
 */
gc.gis.module.GCDigitize.Impl.prototype.getFeatures = function()
{
	return this.getLayer().getFeatures();
};

/**
 * Setzt die Layer, die für eine Geometrie-Selektion abgefragt werden sollen.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.layer.GCLayer[]} layers
 */
gc.gis.module.GCDigitize.Impl.prototype.setSelectionLayers = gc.gis.abstractMethod;